
import * as helpers from './helpers.js';

function init() {
  if (!window.location.href.includes('/downloads')) return;


  const os = helpers.guessOperatingSystem();

  // current implementation from chop-chop uses jQuery slick
  // https://github.com/kenwheeler/slick

  let initialSlide = 0;
  if (os === 'Mac OSX') initialSlide = 1;
  if (os === 'Linux') initialSlide = 2;

  jQuery('.downloads__files').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    arrows: false,
    dots: false,
    'initialSlide': initialSlide,
  });

  jQuery('.downloads__files-file').removeClass('hidden');

  jQuery('.downloads__files-file-nav .prev').on('click', function() {
    jQuery('.downloads__files').slick('slickPrev');
  });

  jQuery('.downloads__files-file-nav .next').on('click', function() {
    jQuery('.downloads__files').slick('slickNext');
  });
}

export {
  init,
};
